import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAppSelector } from '@/app/hooks'
import { selectIsAuthenticated } from '@/features/auth/authSlice'
import { setPostLoginRedirect } from '@/lib/auth/sessionActivity'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * Protected route component that checks authentication from Redux store
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  if (!isAuthenticated) {
    // Angular AuthGuard.setRedirection(state.url) — restore after re-login
    setPostLoginRedirect(location.pathname + location.search + location.hash)
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

